import React from 'react'
import { HttpServicesProvider } from './context/HttpServicesProvider'
import { HttpServicesMain } from './components/HttpServicesMain'

export const HttpServices = () => (
  <HttpServicesProvider>
    <HttpServicesMain />
  </HttpServicesProvider>
)
